module.exports = __webpack_public_path__ + "static/media/linkedin.fdf771ed.png";